import { OpenAPI } from "../../../common/api/openapi";

export const req = new OpenAPI("/api/cluster");
// NB 2026-03-23 星云机房，无KEC服务，后续需要KCE实现接口
export const kecapi = new OpenAPI("/kecapi", {
  params: { Service: "kec", Version: "2016-03-04" },
});
